// =============================================================================
// Copyright   : 2020 semantics GmbH
// Date        : $Date: 2021-09-01 16:32:46 +0200 (Wed, 01 Sep 2021) $
// Author      : Dirk Rothe
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 121200 $
// Purpose     : logging parts
// =============================================================================
// ---Third-party imports
import React from 'react'
import {funcPart} from 'uix/parts'

import {LogStream} from './components'

export const LogConsole = funcPart(
  {partStyle: {flex: 1, display: 'flex', height: '100%', width: '100%'}},
  ({}) => <LogStream as="div" />
)
